import React, { Component } from "react";
import { Card, Row, Col, Button, Form, Dropdown, Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { saveAs } from "file-saver";
import { connect } from "react-redux";
import styled from "styled-components";
import ModalLoader from "../Loader/ModalLoader";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import download from "../../../assets/img/svg/ticket-icons/citation-download.svg";
import {
  SuperAdminAction,
  TicketActions,
  EnforcementActions,
} from "../../Actions";
import Loader from "../Loader/Loader";
import CustomContentAlert, {
  tableHeightScrollBarsTab,
  findBySearch,
  utcToSpecificTimeZone,
  scroolToTop,
  isEmailValid,
} from "../helper";
import isEqual from "lodash/isEqual";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PropertDetails from "../LandingPage/PropertySelection";
import moment from "moment";
import SendMailModal from "../Ticket/SendMailModal";
import { isMobile } from "react-device-detect";
const moment_timezone = require("moment-timezone");
class RevenueReport extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - 30);
    this.state = {
      PropertyId: this.props.PropertyId,
      ticketList: [],
      ticketSummary: [],
      loader: false,
      user_type: this.props.user_type,
      suite_id: this.props.suite_id,
      confirmRemoveResidence: false,
      confirmRemoveResidenceData: null,
      uuid: "",
      searchValue: "",
      prevSearch: "",
      prevPage: "",
      prevNorow: "",
      // ticketList: [],
      api_response: false,
      show_alert: false,
      show_alert_on_remove_resident: false,
      show_error_on_remove_resident: false,
      api_success_message: "",
      api_error_message: "",
      page: 1,
      Norow: 100,
      selectedColumn: "created_at",
      asc: "false",
      sort_direction: "DESC",
      pageChanged: false,
      findMore: false,
      count: 0,
      timezone: this.props.timezone,
      property: this.props.property,
      showModal: false,
      isFormValid: true,
      status: "",
      remark: "",
      validStatus: true,
      validRemark: true,
      show: false,
      showTicketDetails: false,
      ticketDetails: {},
      state: "",
      ticketPdfUrl: "",
      isSendMailModalOpen: false,
      emailToSend: "",
      isMailFormValid: false,
      selectedReceiptId: "",
      isMailModal: false,
      selectedProperty: "",
      selectedPropertyObj: {},
      all_proparties: [],
      childcheckbox: true,
      ticketReportLots: [],
      lot_id: "",
      currentLOT: [],
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
      currentDate: "",
      month: "",
      year: "",
      selectedRadio: "",
      detectedDevice: "",
      activeTab: "1",
      currentSummaryDate: "",
      summaryMonth: "",
      lotsSummary: [],
      apiResponse: "",
      pdfLoader: false,
      searchedticketList: [],
      dateRanges: [
        {
          startDate: new Date(),
          endDate: null,
          key: "selection",
        },
      ],
      exportLink: false,
      // exportButtonDisable: false,
      finalTableHeight: 0,
      daysDifference: 30,
    };

    this.customStyles = {
      rows: {
        style: {
          minHeight: "72px", // override the row height
        },
      },
      headCells: {
        style: {
          paddingLeft: "8px", // override the cell padding for head cells
          paddingRight: "8px",
        },
      },
      cells: {
        style: {
          paddingLeft: "8px", // override the cell padding for data cells
          paddingRight: "8px",
        },
      },
    };

    this.columns = [
      {
        name: "Meter",
        sortable: true,
        width: "180px",
        cell: (row) => <div>{row.agent_id ? row.agent_id : "-"}</div>,
        selector: (row) => row.agent_id,
      },
      {
        name: "Location",
        sortable: true,
        width: "180px",
        cell: (row) => (
          <div>{row.meter_location ? row.meter_location : "-"}</div>
        ),
        selector: (row) => row.meter_location,
      },
      {
        name: "Entry Time",
        sortable: true,
        width: "160px",
        cell: (row) => (
          <div>
            {row.entry_time
              ? utcToSpecificTimeZone(this.props.timezone, row.entry_time)
              : "-"}
          </div>
        ),
        selector: (row) => row.entry_time,
      },
      {
        name: "Transaction Time",
        sortable: true,
        width: "160px",
        cell: (row) => (
          <div>
            {row.transaction_time
              ? utcToSpecificTimeZone(this.props.timezone, row.transaction_time)
              : "-"}
          </div>
        ),
        selector: (row) => row.transaction_time,
      },
      {
        name: "Amount",
        sortable: true,
        width: "140px",
        cell: (row) => <div>${parseFloat(row.amount).toFixed(2)}</div>,
        selector: (row) => row.amount,
      },
      {
        name: "Ticket Barcode Number",
        width: "200px",
        sortable: true,
        cell: (row) => <div>{row.barcode_no}</div>,
        selector: (row) => row.barcode_no,
      },
      {
        name: "Receipt Number",
        sortable: true,
        width: "160px",
        cell: (row) => (
          <div
            className="curserPointer"
            onClick={() => {
              this.handleShowReceiptDetails(row);
            }}
          >
            <div>{row.invoice_no}</div>
          </div>
        ),
        selector: (row) => row.invoice_no,
      },
      {
        name: "Card Type",
        sortable: true,
        width: "160px",
        cell: (row) => <div>{row.card_type}</div>,
        selector: (row) => row.card_type,
      },
      {
        name: "Transaction Number",
        sortable: true,
        width: "160px",
        cell: (row) => <div>{row.transaction_id}</div>,
        selector: (row) => row.transaction_id,
      },
      {
        name: "LPN",
        width: "160px",
        sortable: true,
        cell: (row) => <div>{row.lpn}</div>,
        selector: (row) => row.lpn,
      },
      {
        name: "Card",
        sortable: true,
        width: "140px",
        cell: (row) => <div>{row.card}</div>,
        selector: (row) => row.card,
      },
      {
        name: "Completed",
        sortable: true,
        minWidth: "140px",
        cell: (row) => <div>{row.completed}</div>,
        selector: (row) => row.completed,
      },
    ];
  }

  handleShowReceiptDetails = async (row) => {
    console.log("this is the row", row);
    this.setState(
      {
        showReceiptModal: true,
        pdfLoader: true,
      },
      async () => {
        if (row) {
          const data = await this.props.getReceiptPDF(row);
          if (this.props.api_response) {
            this.setState({
              pdfUrl: data,
              selectedReceiptId: row.id,
              pdfLoader: false,
            });
          }
        }
      }
    );
  };

  closeModal = () => {
    this.setState({
      showReceiptModal: false,
    });
  };

  changeProperty(event) {
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - 30);
    this.setState(
      {
        selectedProperty: event.value,
        selectedPropertyObj: event,
        startDate: new Date(datebeforeThirtyDays),
        endDate: new Date(),
        month: null,
        year: null,
        currentDate: null,
        selectedRadio: null,
      },
      () => {
        const selectedPropertyObj = this.state.all_proparties.find(
          (item) => item.id === this.state.selectedProperty
        );
        this.props.selected_Property(selectedPropertyObj);
        this.props.get_all_lots(event.value);
        const current_lot = this.props.lots;
        this.setState({
          ticketReportLots: current_lot,
        });
        this.setState({
          isFormValid: true,
          pageDropdownDisabled: false,
        });
      }
    );
  }

  handleCheckBox = () => {
    this.setState({ childcheckbox: !this.state.childcheckbox });
  };

  componentDidMount = async () => {
    await this.getTickets();
    await this.props.get_all_properties();
    const { PropertyId } = this.state;
    await this.props.get_all_lots(PropertyId);
    const current_lot = this.props.lots;
    this.setState(
      {
        api_response: this.props?.api_response,
        all_properties: this.props?.getAllProperties,
        ticketReportLots: current_lot,
      },
      async () => {
        const selectedPropertyObj = this.state.all_properties.find(
          (item) => item.id === PropertyId
        );
        console.log("selectedPropertyObjaaa", selectedPropertyObj);
        if (selectedPropertyObj) {
          this.setState({
            selectedPropertyObj: {
              label: selectedPropertyObj.site_name,
              value: selectedPropertyObj.id,
            },
            selectedProperty: PropertyId,
            selectedDomainName: selectedPropertyObj.site_name,
            selectedPropertyName: selectedPropertyObj.domain,
          });
        }
      }
    );
    const height = tableHeightScrollBarsTab();
    const detectedDevice = this.getMobileOperatingSystem();
    this.setState(
      {
        detectedDevice: detectedDevice,
        finalTableHeight: height,
      },
      () => {
        console.log(
          "showReceiptModal: true,showReceiptModal: true,",
          this.state.detectedDevice
        );
      }
    );
  };

  getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  };

  getTickets = async () => {
    this.setState({ loader: true }, async () => {
      const {
        page,
        Norow,
        state,
        selectedColumn,
        sort_direction,
        PropertyId,
        childcheckbox,
        timezone,
        startDate,
        endDate,
      } = this.state;
      const pageobj = {
        page,
        Norow,
        state,
        selectedColumn,
        sort_direction,
        PropertyId,
        childcheckbox,
        timezone,
      };
      if (startDate) {
        pageobj.startDate = startDate;
      }
      if (endDate) {
        pageobj.endDate = endDate;
      }
      await this.props.getRevenueList(pageobj);
      const selectedPropertyName = this.state.property?.property_name;
      const selectedDomainName = this.state.property?.domain;
      await this.props.setDomainHeader(
        selectedPropertyName,
        selectedDomainName
      );
      this.setState({
        ticketList:
          this.props.ticketList &&
          this.props.ticketList.rows &&
          this.props.ticketList.rows.length
            ? JSON.parse(JSON.stringify(this.props.ticketList.rows))
            : [],
        api_response: this.props.api_response,
        count: this.props.ticketList.count,
      });
      this.setState({ loader: false });
    });
  };

  componentDidUpdate = async (prevProps) => {
    if (!isEqual(prevProps.ticketList, this.props.ticketList)) {
      this.setState({
        //  ticketList: JSON.parse(JSON.stringify(this.props.ticketList.rows)),
        searchedticketList: JSON.parse(
          JSON.stringify(this.props.ticketList.rows)
        ),
        pageChanged: true,
        count: this.props.ticketList.count,
      });
    }
    if (!isEqual(prevProps.ticketSummary, this.props.ticketSummary)) {
      this.setState({
        ticketSummary: JSON.parse(
          JSON.stringify(this.props.ticketSummary.rows)
        ),
        // ticketList: JSON.parse(JSON.stringify(this.props.ticketList.rows)),
        pageChanged: true,
        count: this.props.ticketSummary.count,
      });
    }
    if (!isEqual(prevProps.lots, this.props.lots)) {
      this.setState({
        ticketReportLots: this.props.lots,
        lotsSummary: this.props.lots,
      });
    }
  };

  dataTableHandle = (ticketList) => {
    return (
      <DataTable
        data={
          this.state.searchValue.length
            ? this.state.searchedticketList
            : ticketList
        }
        columns={this.columns}
        customStyles={this.customStyles}
        responsive={true}
        defaultSortAsc={true}
        fixedHeader={true}
        onChangePage={scroolToTop}
        fixedHeaderScrollHeight={this.state.finalTableHeight}
        pagination={true}
        paginationPerPage={this.state.Norow}
        paginationTotalRows={this.state.count}
        paginationRowsPerPageOptions={[100, 200, 300, 400]}
      />
    );
  };

  handleChangeLot = ({ target }) => {
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(today.getDate() - 30);
    this.setState({
      [target.name]: target.value,
      month: null,
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
      year: null,
      currentDate: null,
      selectedRadio: null,
    });
  };

  handleCurrentDate = (date) => {
    this.setState({
      currentDate: date,
      month: null,
      year: null,
      startDate: null,
      endDate: null,
      selectedRadio: null,
    });
  };

  handleChangeStartingDates = (date) => {
    const dt = new Date(date);
    const getEndDate = dt.setMonth(dt.getMonth() + 6);
    let selectEndDate;
    if (getEndDate > new Date()) {
      selectEndDate = new Date();
    } else {
      selectEndDate = getEndDate;
    }
    this.setState({
      startDate: date,
      endDate: selectEndDate,
      month: null,
      year: null,
      currentDate: null,
      selectedRadio: null,
    });
  };

  handleChangeEndDates = (date) => {
    this.setState({
      endDate: date,
      month: null,
      year: null,
      currentDate: null,
      selectedRadio: null,
    });
  };

  onDocumentLoadSuccess = ({ numPages }) => {
    console.log("numPages", numPages);
  };

  handleSearch = () => {
    this.setState({ loader: true }, async () => {
      const {
        page,
        Norow,
        selectedColumn,
        sort_direction,
        lot_id,
        childcheckbox,
        month,
        year,
        currentDate,
        startDate,
        endDate,
        selectedRadio,
        selectedPropertyObj,
        PropertyId,
        exportLink,
        timezone,
      } = this.state;
      const pageobj = {
        page,
        Norow,
        selectedColumn,
        sort_direction,
        childcheckbox,
        PropertyId,
        timezone,
        exportLink,
      };
      if (Object.keys(selectedPropertyObj).length) {
        pageobj.PropertyId = selectedPropertyObj.value;
      } else {
        pageobj.PropertyId = PropertyId;
      }
      if (lot_id) {
        pageobj.lot_id = lot_id;
      }
      if (selectedRadio) {
        pageobj.selectedRadio = selectedRadio;
      }
      if (currentDate) {
        pageobj.currentDate = currentDate;
      }
      if (month) {
        pageobj.month = month;
      }
      if (year) {
        pageobj.year = moment_timezone(year).format("YYYY");
      }
      if (startDate && endDate) {
        pageobj.startDate = startDate;
        pageobj.endDate = endDate;
      }
      await this.props.getRevenueList(pageobj);

      this.setState({
        ticketList: JSON.parse(JSON.stringify(this.props.ticketList.rows)),
        api_response: this.props.api_response,
        count: this.props.ticketList.count,
        // exportButtonDisable: false,
      });
      this.setState({ loader: false });
      document.body.classList.remove("foc-open");
    });
  };

  resetAll = async () => {
    const today = new Date();
    const datebeforeThirtyDays = today.setDate(
      today.getDate() - this.state.daysDifference
    );
    this.setState({
      selectedRadio: null,
      month: null,
      year: null,
      currentDate: null,
      selectedPropertyObj: {},
      lot_id: "",
      childcheckbox: true,
      startDate: new Date(datebeforeThirtyDays),
      endDate: new Date(),
      // exportButtonDisable: true,
    });
    const {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      PropertyId,
      exportLink,
      selectedDomainName,
      timezone,
      startDate,
      endDate,
    } = this.state;
    const pageobj = {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      PropertyId,
      exportLink,
      timezone,
    };
    if (startDate) {
      pageobj.startDate = new Date(datebeforeThirtyDays);
    }
    if (endDate) {
      pageobj.endDate = new Date();
    }
    await this.props.getRevenueList(pageobj);
    this.setState({
      pageChanged: true,
      page: 1,
      ticketList: this.props.ticketList.rows,
      count: this.props.ticketList.count,
      selectedPropertyObj: {
        label: selectedDomainName,
        value: PropertyId,
      },
    });
    setTimeout(() => {
      this.setState({ findMore: false });
    }, 2000);
    this.setState({ loader: false });
    document.body.classList.remove("foc-open");
  };

  handleExport = async (type) => {
    const {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      lot_id,
      childcheckbox,
      month,
      year,
      currentDate,
      startDate,
      endDate,
      selectedRadio,
      selectedPropertyObj,
      PropertyId,
      exportLink,
      selectedDomainName,
      timezone,
    } = this.state;
    const pageobj = {
      page,
      Norow,
      selectedColumn,
      sort_direction,
      childcheckbox,
      PropertyId,
      timezone,
      exportLink,
    };
    if (Object.keys(selectedPropertyObj).length) {
      pageobj.PropertyId = selectedPropertyObj.value;
    } else {
      pageobj.PropertyId = PropertyId;
    }
    if (lot_id) {
      pageobj.lot_id = lot_id;
    }
    if (selectedRadio) {
      pageobj.selectedRadio = selectedRadio;
    }
    if (currentDate) {
      pageobj.currentDate = currentDate;
    }
    if (month) {
      pageobj.month = month;
    }
    if (year) {
      pageobj.year = moment_timezone(year).format("YYYY");
    }
    if (startDate && endDate) {
      pageobj.startDate = startDate;
      pageobj.endDate = endDate;
    }
    if (type === "excel") {
      pageobj.exportLink = true;
      pageobj.pdfLink = false;
      const bufferData = await this.props.getRevenueList(pageobj);
      const currentTimeDate = moment().format("YYYYMMDD-hhmmss");
      const exportDataName = `REVENUE-${currentTimeDate}-${selectedDomainName}.xls`;
      if (bufferData) {
        saveAs(
          new Blob([bufferData], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }),
          exportDataName
        );
      }
    } else if (type === "pdf") {
      pageobj.pdfLink = true;
      pageobj.exportLink = false;
      const pdfdata = await this.props.getRevenueList(pageobj);
      if (pdfdata) {
        saveAs(
          new Blob([pdfdata], { type: "application/pdf" }),
          `Revenue_Reports.pdf`
        );
      }
    }
  };

  hideSlider = () => {
    document.body.classList.remove("foc-open");
  };

  handleSearchChange = async ({ target }) => {
    this.setState({ searchValue: target.value }, async () => {
      const columnList = [
        "agent_id",
        "meter_location",
        "created_at",
        "transaction_time",
        "barcode_no",
        "id",
        "card_type",
        "transaction_id",
        "lpn",
        "card",
        "completed",
        "amount",
      ];
      if (this.state.searchValue.length) {
        if (!this.state.findMore) {
          this.setState(
            {
              searchedticketList: findBySearch(
                this.state.searchValue,
                this.state.ticketList,
                this.state.ticketList,
                columnList,
                this.props.timezone
              ),
            },
            () => {
              this.setState({ count: this.state.searchedticketList.length });
            }
          );
        }
      } else {
        this.setState({
          count: this.props.ticketList.count,
          searchedticketList: [],
          ticketList: this.props.ticketList.rows,
        });
      }
    });
  };

  handleMailChange = (e) => {
    this.setState(
      {
        emailToSend: e.target.value,
      },
      () => {
        if (!this.state.emailToSend.trim().length) {
          this.setState({
            emailError: "Please Enter email!",
          });
        }
        if (this.state.emailToSend.trim().length) {
          this.setState({
            emailError: !isEmailValid(this.state.emailToSend)
              ? "Email is invalid!"
              : "",
            isMailFormValid: isEmailValid(this.state.emailToSend),
          });
        }
      }
    );
  };

  sendMailClick = () => {
    const { emailToSend } = this.state;
    const type = "pdf";
    const sendMailData = {
      type,
      emailToSend,
      receiptId: this.state.selectedReceiptId,
    };
    this.ticketDataPdf(sendMailData);
  };

  ticketDataPdf = async (sendMailData) => {
    await this.props.pdfSendToMail(sendMailData);
    if (this.props.api_response) {
      this.setState({
        show_alert: true,
        api_success_message: this.props.api_success_message,
        isSendMailModalOpen: false,
        showReceiptModal: false,
        emailToSend: "",
      });
      setTimeout(() => {
        this.setState({ show_alert: false });
      }, 4000);
    }
  };

  render() {
    const {
      //  exportButtonDisable,
      ticketList,
      loader,
      // page,
      // Norow,
      childcheckbox,
      ticketReportLots,
      lot_id,
      startDate,
      endDate,
      currentDate,
      // month,
      searchValue,
      // year,
      // daysDifference,
    } = this.state;

    return (
      <div>
        <div fluid>
          <Card className="mb-0">
            <Card.Body className="pos-rel-overflow-hide">
              <>
                <div className="sidebarFilter">
                  <Card className="contact-container mb-0">
                    <Card.Header
                      style={{ backgroundColor: this.props.main_body }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <Card.Title as="h4">Revenue Details</Card.Title>
                        <a
                          onClick={this.hideSlider}
                          href="javascript:void(0);"
                          className="btn btn-sm border-0 bg-light rounded-circle  w-30px h-30px d-flex align-items-center justify-content-center"
                        >
                          <i className="fa fa-times" aria-hidden="true"></i>
                        </a>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col md="12">
                          <div className="mb-2">
                            <label className="fancy-checkbox">
                              <input
                                type="checkbox"
                                name={"childcheckbox"}
                                checked={childcheckbox}
                                onChange={this.handleCheckBox}
                                className="custom-control-input"
                                id="childcheckbox1"
                              ></input>
                              <span>
                                <i></i>Include Children Sites
                              </span>
                            </label>
                          </div>
                        </Col>
                        <Col md="12">
                          <PropertDetails
                            selectedPropertyObj={this.state.selectedPropertyObj}
                            changeProperty={this.changeProperty.bind(this)}
                          />
                        </Col>
                        <Col md="12">
                          <Form.Group controlId="exampleForm.ControlSelect1">
                            <Form.Label>LOTS:</Form.Label>
                            <Form.Control
                              as="select"
                              name="lot_id"
                              value={lot_id}
                              onChange={this.handleChangeLot}
                              disabled={ticketReportLots.length < 1}
                              placeholder="Select Lot"
                            >
                              {ticketReportLots && ticketReportLots.length ? (
                                <>
                                  <option value="">Any</option>
                                  {ticketReportLots.map((item, index) => (
                                    <option key={index} value={item.id}>
                                      {item.alias}
                                    </option>
                                  ))}
                                </>
                              ) : null}
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        {/* <Col md="12">
                          <Form.Group>
                            <label className="mb-0 mr-2">MONTH:</label>
                            <DatePicker
                              className="form-control"
                              placeholderText="Select Month"
                              selected={month}
                              value={month}
                              disabled={loader}
                              onChange={this.handleMonth}
                              dateFormat="MM/yyyy"
                              showMonthYearPicker
                            />
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <label className="mb-0 mr-2">YEAR:</label>
                            <DatePicker
                              className="form-control"
                              placeholderText="Select Year"
                              selected={year}
                              defaultHour={24}
                              value={year}
                              disabled={loader}
                              onChange={this.handleYear}
                              showYearPicker
                              dateFormat="yyyy"
                            />
                          </Form.Group>
                        </Col> */}
                        <Col md="12">
                          <Form.Group>
                            <label className="mb-0 mr-2">DATE:</label>
                            <DatePicker
                              className="form-control"
                              placeholderText="Select Date"
                              selected={currentDate}
                              value={currentDate}
                              disabled={loader}
                              selectsStart
                              timeInputLabel="Time:"
                              onChange={this.handleCurrentDate}
                              dateFormat="MM/dd/yyyy"
                            />
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <label className="mb-0 mr-2">START DATE:</label>
                            <DatePicker
                              className="form-control"
                              placeholderText="Select Start Date"
                              selected={startDate}
                              defaultHour={24}
                              value={startDate}
                              disabled={loader}
                              selectsStart
                              timeInputLabel="Time:"
                              onChange={this.handleChangeStartingDates}
                              dateFormat="MM/dd/yyyy"
                              startDate={startDate}
                              endDate={endDate}
                              maxDate={new Date()}
                            />
                          </Form.Group>
                        </Col>
                        <Col md="12">
                          <Form.Group>
                            <label className="mb-0 mr-2">END DATE:</label>
                            <DatePicker
                              className="form-control"
                              placeholderText="Select End Date"
                              selected={endDate}
                              disabled={loader}
                              value={endDate}
                              selectsEnd
                              timeInputLabel="Time:"
                              onChange={this.handleChangeEndDates}
                              // dateFormat="MM/dd/yyyy hh:mm:ss aa"
                              dateFormat="MM/dd/yyyy"
                              // showTimeInput
                              startDate={startDate}
                              endDate={endDate}
                              minDate={startDate}
                              maxDate={endDate}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </Card.Body>
                    <Card.Footer className="text-right justify-content-between d-flex">
                      <Button
                        variant="info"
                        className="h-40 custom-btn-secondary btn-sm"
                        onClick={this.resetAll}
                        disabled={loader}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="info"
                        className="h-40 btn-fill btn-sm ml-2"
                        onClick={this.handleSearch}
                        disabled={loader}
                      >
                        Search
                      </Button>
                    </Card.Footer>
                  </Card>
                </div>
                <header>
                  <div className="active-permit-header sm-flex-column sm-align-items-start">
                    <h5 className="mb-2 mb-md-0">Revenue Details</h5>
                    <div className="filter-button d-flex flex-wrap">
                      <div className="d-flex align-items-center search-mb-0">
                        <DatatableHeader
                          className="mt-0 mb-0"
                          searchValue={searchValue}
                          HandleChange={this.handleSearchChange}
                          // findMorePressed={this.findMorePressed}
                        />
                      </div>
                      <div className="buttons-dd">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="Primary"
                            id="dropdown-basic"
                            className="btn btn-sm border-0 bg-light  w-30px h-30px d-flex align-items-center justify-content-center ml-2"
                          >
                            <i
                              className="fa fa-ellipsis-v"
                              aria-hidden="true"
                            ></i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="min-w-100px">
                            <Dropdown.Item
                              className="text-sm"
                              onClick={() => this.handleExport("excel")}
                              disabled={
                                this.state.ticketList.length > 0 ? 0 : 1
                              }
                            >
                              <span>Export</span>{" "}
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="text-sm"
                              onClick={() => this.handleExport("pdf")}
                              disabled={
                                this.state.ticketList.length > 0 ? 0 : 1
                              }
                            >
                              <span>Pdf</span>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                </header>
              </>
              {loader ? (
                <Loader />
              ) : (
                <>
                  {this.state.show_alert && (
                    <CustomContentAlert
                      delay={2000}
                      message={this.state.api_success_message}
                      className="toast-success"
                    />
                  )}
                  {ticketList && (
                    <>
                      <div className="citation-list-table list-of-ravenue-table">
                        {this.dataTableHandle(ticketList)}
                      </div>
                    </>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </div>
        {
          <Modal show={this.state.showReceiptModal} onHide={this.closeModal}>
            <Modal.Header className="no-border">
              <Modal.Title as="h4" className="m-0">
                <h4 className="m-0 font-weight-bold">Parking Receipt</h4>
              </Modal.Title>
              <Button
                title={"Close"}
                type="button"
                onClick={this.closeModal}
                className="close-btn py-0"
                data-dismiss="modal"
              >
                <i className="nc-icon nc-simple-remove"></i>
              </Button>
            </Modal.Header>
            <Modal.Body className="modal-data-body">
              {this.state.pdfLoader ? (
                <PdfContainer>
                  <ModalLoader />
                </PdfContainer>
              ) : (
                <Card>
                  <>
                    {this.state.pdfUrl && !isMobile && (
                      <>
                        <EmbedIframe
                          className={"pdf-frame"}
                          src={this.state.pdfUrl}
                          rotate={180}
                        />
                      </>
                    )}
                    {this.state.pdfUrl && isMobile && (
                      <>
                        {this.state.detectedDevice === "iOS" && (
                          <EmbedIframe
                            className={"pdf-frame"}
                            src={this.state.pdfUrl}
                            rotate={180}
                          />
                        )}
                        {this.state.detectedDevice !== "iOS" && (
                          <div>
                            <Document
                              file={this.state.pdfUrl}
                              onLoadSuccess={this.onDocumentLoadSuccess}
                            >
                              <Page pageNumber={1} />
                            </Document>
                          </div>
                        )}
                      </>
                    )}
                  </>
                </Card>
              )}
            </Modal.Body>
            <Modal.Footer>
              <a
                id="pdf"
                href={this.state.pdfUrl}
                target={"_blank"}
                rel="noopener noreferrer"
                style={{ display: "none" }}
              >
                pdf
              </a>
              <Row>
                <Dropdown className="m-0" id="ignoreButton2">
                  <Dropdown.Toggle>
                    <img className="ml-0" src={download} width={18} /> Save as
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        document.getElementById("pdf").click();
                      }}
                    >
                      PDF
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown className="m-0 ml-2" id="ignoreButton2">
                  <Dropdown.Toggle>
                    {/* <img className="" src={email} width={18} /> */}
                    Send mail as
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() =>
                        this.setState({
                          isSendMailModalOpen: true,
                          showReceiptModal: false,
                        })
                      }
                    >
                      PDF
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <Button
                  id="ignoreButton3"
                  className="btn-fill ml-0 mt-2 mt-sm-0 ml-sm-2"
                  type="button"
                  variant="secondary"
                  onClick={this.closeModal}
                >
                  {/* <img className="ml-0 mr-1" src={cancel} width={18} /> */}
                  Cancel
                </Button>
              </Row>
            </Modal.Footer>
          </Modal>
        }
        {this.state.isSendMailModalOpen && (
          <SendMailModal
            closeModal={() => this.setState({ isSendMailModalOpen: false })}
            handleMailChange={this.handleMailChange}
            emailToSend={this.state.emailToSend}
            emailError={this.state.emailError}
            ticketDataPdf={this.sendMailClick}
            isMailFormValid={this.state.isMailFormValid}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({
  UserProfileDetails,
  APIResponseDetails,
  Logindetails,
  SuperAdminDetails,
  CurrentPermitDetails,
  EnforcementDetails,
}) => {
  const { api_response, api_error_message, api_success_message } =
    APIResponseDetails;
  const {
    property_id: PropertyId,
    user_type,
    suite_id,
    timezone,
    property,
  } = UserProfileDetails;
  const { revenueList: ticketList, citationSummaryList: ticketSummary } =
    EnforcementDetails;
  const { backgroundColor } = Logindetails;
  const { residentList } = CurrentPermitDetails;
  const { getAllProperties, lots, receiptPDFData } = SuperAdminDetails;
  const { MainBackground: main_body } = backgroundColor;
  return {
    api_response,
    api_error_message,
    api_success_message,
    PropertyId,
    user_type,
    receiptPDFData,
    suite_id,
    timezone,
    property,
    ticketList,
    main_body,
    getAllProperties,
    residentList,
    lots,
    ticketSummary,
  };
};

const mapStateToDispatch = {
  setDomainHeader: SuperAdminAction.setDomainHeader,
  getReceiptPDF: SuperAdminAction.getReceiptPDF,
  getRevenueList: EnforcementActions.getRevenueList,
  doCloseTicket: TicketActions.doCloseTicket,
  ticketStatusChange: TicketActions.ticketStatusChange,
  pdfSendToMail: SuperAdminAction.pdfSendToMail,
  get_all_properties: SuperAdminAction.get_all_properties,
  selected_Property: SuperAdminAction.selected_Property,
  get_all_lots: SuperAdminAction.get_all_lots,
  getCitationIssuedSummary: EnforcementActions.getCitationIssuedSummary,
};

export default connect(mapStateToProps, mapStateToDispatch)(RevenueReport);
const EmbedIframe = styled.iframe`
  width: 100%;
  height: calc(100vh - 200px);
  rotate: degrees(-45);
`;
const PdfContainer = styled.div`
  width: 100%;
  height: calc(100vh - 200px);
`;
